import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const cloudflare = defineConnector({
  identifier: "cloudflare",
  name: "Cloudflare",
  tagLine: "Web performance and security",
  keywords: "cdn dns waf ddos zones workers zero trust",
  logo,
  protocol: "http",
  tags: ["security", "engineering"],
  defaultUrlPattern: () => "https://api\\.cloudflare\\.com/.*",
  auth: (app) => bearerAuth(app.secret.apiToken),
  steps: [
    {
      title: "Get your Cloudflare API token",
      items: [
        {
          kind: "markdown",
          content:
            "In Cloudflare, go to **My Profile > API Tokens** and create a new token with the permissions you need. We recommend using API tokens over global API keys for better security.",
        },
      ],
    },
    {
      title: "Enter your API token",
      items: [
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.cloudflare.com/client/v4/user/tokens/verify",
  },
});
